import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InsightsState } from 'app-redux/InsightsState';
import * as dto from 'client/dto';
import { nameof } from 'utils/typeHelpers';

export type BepiState = {
  bepiValuesByLocationIdAndCategory: Record<number, Record<dto.BepiCategory, number>>;
  bepiLocationNameByLocationId: Record<number, string>;
};

export const InitialBepiState: BepiState = {
  bepiValuesByLocationIdAndCategory: {},
  bepiLocationNameByLocationId: {},
};

const bepiSlice = createSlice({
  name: nameof<InsightsState>('bepi'),
  initialState: InitialBepiState,
  reducers: {
    loadBepiForLocationSuccess: (
      state,
      action: PayloadAction<{
        locationId: number;
        locationBepiModel: dto.LocationBepiModel;
      }>
    ) => {
      const locationBepiModel: dto.LocationBepiModel = action.payload.locationBepiModel;
      const locationId: number = action.payload.locationId;
      state.bepiValuesByLocationIdAndCategory[locationId] = {} as Record<dto.BepiCategory, number>;
      locationBepiModel.bepiValues.forEach(bepiValue => {
        state.bepiValuesByLocationIdAndCategory[locationId][bepiValue.category] = bepiValue.value;
      });
      state.bepiLocationNameByLocationId[locationId] = locationBepiModel.locationName;
    },
  },
});

const { actions, reducer } = bepiSlice;
export const { loadBepiForLocationSuccess } = actions;
export default reducer;
